import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { CancelableRequestProducer } from './types'

export class ApiInstance {
  client: AxiosInstance

  constructor(config?: AxiosRequestConfig) {
    this.client = axios.create(config)
  }

  get<T extends unknown = unknown>(url: string, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return (signal) => this.client.get<T>(url, { ...config, signal })
  }

  post<T extends unknown = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): CancelableRequestProducer<T> {
    return (signal) => this.client.post<T>(url, data, { ...config, signal })
  }

  put<T extends unknown = unknown>(url: string, data?: unknown, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return (signal) => this.client.put<T>(url, data, { ...config, signal })
  }

  patch<T extends unknown = unknown>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig,
  ): CancelableRequestProducer<T> {
    return (signal) => this.client.patch<T>(url, data, { ...config, signal })
  }

  delete<T extends unknown = unknown>(url: string, config?: AxiosRequestConfig): CancelableRequestProducer<T> {
    return (signal) => this.client.delete<T>(url, { ...config, signal })
  }
}

export const createApi = (config?: AxiosRequestConfig) => new ApiInstance(config)
